<template lang="pug">
span.table-column-resize(
  role="separator"
  tabindex="0"
  aria-orientation="vertical"
  :aria-label="'Ширина колонки «' + label + '»'"
  :aria-valuenow="width"
  :aria-valuemin="minWidth"
  aria-valuemax="1200"
  :class="{ 'table-column-resize--active': resizing, 'table-column-resize--left': edge === 'left' }"
  @pointerdown.stop.prevent="start"
  @click.stop.prevent
  @keydown.stop="onKeydown"
  @keyup.stop="onKeyup"
  @blur="stop"
)
</template>

<script>
export default {
  name: 'ColumnResize',
  props: {
    label: { type: String, default: '' },
    width: { type: Number, required: true },
    edge: { type: String, default: 'right' },
    minWidth: { type: Number, default: 80 }
  },
  data () {
    return { resizing: false, startX: 0, startWidth: 0, pointerId: null }
  },
  beforeDestroy () {
    this.stop()
  },
  methods: {
    renderedWidth () {
      return this.$el.closest('th')?.getBoundingClientRect().width || this.width
    },
    start (event) {
      if (event.button !== 0 || !event.isPrimary) return
      this.startX = event.clientX
      this.startWidth = this.renderedWidth()
      this.pointerId = event.pointerId
      this.resizing = true
      window.addEventListener('pointermove', this.move)
      window.addEventListener('pointerup', this.stop)
      window.addEventListener('pointercancel', this.cancel)
      window.addEventListener('blur', this.stop)
      this.$emit('start')
    },
    move (event) {
      if (!this.resizing || event.pointerId !== this.pointerId) return
      event.preventDefault()
      const direction = this.edge === 'left' ? -1 : 1
      this.resize(this.startWidth + ((event.clientX - this.startX) * direction))
    },
    stop (event, commit = true) {
      if (event && ['pointerup', 'pointercancel'].includes(event.type) && event.pointerId !== this.pointerId) return
      const wasResizing = this.resizing
      this.resizing = false
      this.pointerId = null
      window.removeEventListener('pointermove', this.move)
      window.removeEventListener('pointerup', this.stop)
      window.removeEventListener('pointercancel', this.cancel)
      window.removeEventListener('blur', this.stop)
      if (wasResizing) this.$emit('end', commit)
    },
    cancel (event) {
      this.stop(event, false)
    },
    resize (width) {
      this.$emit('resize', Math.round(Math.max(this.minWidth, Math.min(1200, width))))
    },
    onKeydown (event) {
      const step = event.shiftKey ? 40 : 10
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return
      event.preventDefault()
      const currentWidth = this.renderedWidth()
      if (!this.resizing) {
        this.resizing = true
        window.addEventListener('blur', this.stop)
        this.$emit('start')
      }
      const width = event.key === 'Home' ? this.minWidth : event.key === 'End' ? 1200
        : currentWidth + (event.key === 'ArrowRight' ? step : -step)
      this.resize(width)
    },
    onKeyup (event) {
      if (this.pointerId === null && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) this.stop()
    }
  }
}
</script>

<style lang="sass">
.table-column-resize
  position: absolute
  right: -4px
  top: 0
  bottom: 0
  width: 9px
  cursor: col-resize
  touch-action: none
  z-index: 3

  &--left
    right: auto
    left: -4px

  &::after
    content: ''
    position: absolute
    left: 4px
    top: 6px
    bottom: 6px
    width: 2px
    background: currentColor
    opacity: .18

  &:hover::after, &:focus-visible::after, &--active::after
    opacity: 1
</style>
